var OCS = OCS || {};
OCS.Viewer = OCS.Viewer || {};
OCS.Viewer.Classes = OCS.Viewer.Classes || {};
OCS.Viewer.Classes.RadarSelectFeature = new Class({
    Implements: [Options, Events],
    options: {
        selectable_limit: 1,
        selected_id: null
    },
    layer: null,
    range_layer: null,
    select_obj: null,
    mouse_move_obj: null,
    bound_methods: {},
    initialize: function (options) {
        this.setOptions(options);
        this.bound_methods.on_selection_add = this.on_selection_add.bind(this);
        this.bound_methods.on_mouse_move_add = this.on_mouse_move_add.bind(this);
        this.bound_methods.on_mouse_move_remove = this.on_mouse_move_remove.bind(this);
        this.layer = new OCS.Viewer.Classes.DefaultLayer({"style_type":"point_select"});
        this.layer.create();
        var source = this.create_radar_source();
        this.select_obj = this.layer.add_select_feature_click({selectable_limit: this.options.selectable_limit});
        var selected_features = this.select_obj.getFeatures();
        selected_features.on('add', this.bound_methods.on_selection_add);
        var feature = source.getFeatureById(this.options.selected_id);
        if (feature) {
            feature.set('selected', true);
            if (this.options.debug) {
                console.log('map_manager ' + this.map_selector + ': found feature! ' + this.options.selected_id);
            }
            selected_features.push(feature);
        }

        // Range display hover
        this.range_layer = new OCS.Viewer.Classes.DefaultLayer({});
        this.range_layer.create();
        var range_source = this.range_layer.create_point_source();
        this.range_layer.set_source(range_source);
        
        // Mouse hover
        this.mouse_move_obj = this.layer.add_select_feature_mousemove();
        var mouse_move_features = this.mouse_move_obj.getFeatures();
        mouse_move_features.on('add', this.bound_methods.on_mouse_move_add);
        mouse_move_features.on('remove', this.bound_methods.on_mouse_move_remove);
        this.layer.set_source(source);

    },
    create_radar_source: function (options) {
        var source = new ol.source.Vector();
        // Get the site information and store it as points
        var points = [];
        var point, ol_point;
        Object.each(OCS.Constants.RADAR_LOCATIONS, function (site, key) {
            point = ol.proj.transform([Number(site.lon), Number(site.lat)], OCS.Viewer.Config.default_display_projection, OCS.Viewer.Config.default_projection);
            ol_point = new ol.geom.Circle(point, 5000);
            var pointFeature = new ol.Feature(ol_point);
            pointFeature.set('NAME', site.name);
            pointFeature.set('ID', site.id);
            pointFeature.set('POINT', point);
            pointFeature.setId(site.id);
            points.push(pointFeature);
        }.bind(this));
        source.addFeatures(points);

        return source;
    },    
    on_selection_add: function (event) {
        if (event.element.getId() !== this.options.selected_id) {
            this.fireEvent('selected', [{'id': event.element.get('ID'), 'name': event.element.get('NAME')}, true]);
        }
    },
    on_mouse_move_add: function (event) {
        var pointFeature = new ol.Feature(new ol.geom.Circle(event.element.get('POINT'), 228000));
        pointFeature.setId(event.element.get('ID'));
        pointFeature.setStyle(this.range_layer.get_radar_range_feature_style());
        this.range_layer.get_source().addFeatures([pointFeature]);
    },
    on_mouse_move_remove: function(event) {
        this.range_layer.get_source().clear();
    }

});